import DutyView from './views/DutyView.vue';
import DutiesView from './views/DutiesOverview.vue';
import DutyViewHeader from './headers/DutyViewHeader.vue';
import moduleId from './moduleId';
import DutiesHeader from './headers/DutiesHeader.vue';
import DutyViewFactory from '@/modules/myDuties/views/DutyViewFactory.vue';

class DutiesRouteHandler {
  getRoutes = ({ moduleType, router }) => {
    return [
      {
        path: '/myduties',
        name: 'myDuties',
        components: { default: DutyViewFactory, header: DutiesHeader },
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
      },
      {
        path: '/myduties/:dutyId',
        name: 'dutyView',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          backPath: () => {
            return `/`;
          },
        },
        components: { default: DutiesView, header: DutiesHeader },
      },
      {
        path: '/myduties/detail/:dutyId',
        name: 'dutyActivitiesView',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          backPath: (currentRouteParams) => {
            console.debug('getBackPath');
            return `/myduties/${currentRouteParams.dutyId}`;
          },
        },
        components: { default: DutyView, header: DutyViewHeader },
      },

      {
        path: '/myduties/detail/:dutyId/:documentId',
        name: 'dutyActivitiesDocumentView',
        meta: {
          moduleType,
          initiateSyncBeforeNav: false,
          moduleId,
          baseRoute: true,
          backPath: (currentRouteParams) => {
            console.debug('getBackPath');
            return `/myduties/${currentRouteParams.dutyId}`;
          },
        },
        components: { default: DutyView, header: DutyViewHeader },
      },
    ];
  };
}

const routeHandler = new DutiesRouteHandler();
export default routeHandler;
